import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'

const Warning = props => {
    let { paymentData, paymentInfo, additionalData } = props
    let { fail_url, payment_id } = paymentData
    let { depositorypayment_error } = paymentInfo
    let { desc } = additionalData
    let translation = JSON.parse(localStorage.translation)[
        localStorage.language
    ]
    return (
        <div className="payment__box_right">
            <div className="payment__layout payment__layout_error" />
            <p className="payment__title payment__text-size_m payment__margin-bottom_x">
                {translation['Error']}
            </p>
            <div className="payment__icon payment__icon_error payment__margin-bottom_m">
                <FontAwesomeIcon icon={'exclamation-circle'} />
            </div>
            {structureOfError(desc)}
            {desc === 'not_set_2fa' ? getTFALink() : null}
            <a
                href={`${fail_url}depositorypayment_id=${payment_id}&depositorypayment_error=${
                    depositorypayment_error ? depositorypayment_error : 'decline'
                }`}
            >
                <button className="payment__button">{translation['Continue']}</button>
            </a>
        </div>
    )
}

const structureOfError = desc => {
    if (Array.isArray(desc) && desc.length > 1) {
        let listOfError = desc.map((item, i) => {
            return (
                <p
                    key={i}
                    className="payment__desc payment__desc_white payment__margin-bottom_s"
                >
                    {`${i + 1}. ${firstLetterUppercase(item)}`}
                </p>
            )
        })
        return <div className="payment__error-list">{listOfError}</div>
    } else {
        return (
            <p className="payment__desc payment__desc_white payment__title payment__margin-bottom_m">
                {firstLetterUppercase(
                    Array.isArray(desc) ? desc[0] : desc
                )}
            </p>
        )
    }
}

const getTFALink = () => {
    let translation = JSON.parse(localStorage.translation)[
        localStorage.language
    ]
    return (
        <Link to="/investor/settings/tfa">
            <p className="payment__link">
                {translation['Select the type of two-factor authentication']}
            </p>
        </Link>
    )
}

const firstLetterUppercase = str => {
    let translation = JSON.parse(localStorage.translation)[
        localStorage.language
    ]
    switch (str) {
        case 'wrong_id':
            return translation['Payment ID is incorrect']
            break;
        case 'wrong_payment_id':
            return translation['Payment ID is incorrect']
            break;
        case 'wrong_recipient':
            return translation['Invalid recipient']
            break;
        case 'wrong_amount':
            return translation['Invalid payment amount']
            break;
        case 'wrong_currency':
            return translation['Incorrect currency']
            break;
        case 'wrong_description':
            return translation['Incorrect description']
            break;
        case 'wrong_success_url':
            return translation['Invalid URL Path for success']
            break;
        case 'wrong_fail_url':
            return translation['Invalid URL Path for fail']
            break;
        case 'insufficient_funds':
            return translation['Invalid recipient']
            break;
        case 'not_set_2fa':
            return translation['The type of two-factor authentication is not specified']
            break;
        default:
            return (
                str.replace(/[^a-z]/gi, ' ')[0].toUpperCase() +
                str.replace(/[^a-z]/gi, ' ').slice(1)
            )
    }
}

export default Warning
